export enum StorageKey {
  locationAccessGranted = 'locationAccessGranted',
  preferredLocale = 'preferredLocale',
  preferredThemeId = 'preferredThemeId',
  selectedContractorCode = 'selectedContractorCode',
  availableContractorCodes = 'availableContractorCodes',

  encryptedAccessToken = 'encryptedAccessToken',
  encryptedRefreshToken = 'encryptedRefreshToken',
  hashedPinCode = 'hashedPinCode',
  jwtPayload = 'jwtPayload',

  biometricLoginDisabled = 'biometricLoginDisabled',
  hideFutureTasks = 'hideFutureTasks',
  navigationService = 'navigationService',

  demoAccessToken = 'demoAccessToken',
  demoRefreshToken = 'demoRefreshToken',
  demoEncryptionKey = 'demoEncryptionKey',

  selectedProjectUuids = 'selectedProjectUuids',
  selectedTaskTypeUuids = 'selectedTaskTypeUuids',
  selectedAreaPopUuids = 'selectedAreaPopUuids',
  selectedDistributionPointUuids = 'selectedDistributionPointUuids'
}
